import styled from "styled-components";
import {
  ModalContainer as GlobalModalContainer,
  ModalContent as GlobalModalContent,
  ModalBody as GlobalModalBody,
} from "../../../shared/styles/global.styles";
import { TableContainer as GlobalTableContainer } from "../../../components/Table/styles";

export const ContainerFilter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  width: 100%;
`;
export const ContainerButtons = styled.div`
  /* margin-bottom: 16px; */
  display: flex;
  justify-content: space-between;
  gap: 10px;
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 35vh;
  width: 90vw;
`;

// Componentes de modal personalizados com menos padding nas laterais
// export const ModalContainer = styled(GlobalModalContainer)`
//   // Mantém as mesmas propriedades do componente global
// `;

// export const ModalContent = styled(GlobalModalContent)`

// `;

// export const ModalBody = styled(GlobalModalBody)`
//   padding: 32px 20px; // Reduzido de 32px para 20px nos lados
//   overflow-x: hidden; // Previne rolagem horizontal no corpo do modal
// `;

// Container de tabela personalizado para o ModalDetalhes
export const CustomTableContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`;


export const AppliedFilters = styled.div`
  display: flex;
  flex-direction: row;
  width: 90vw;
  min-height: 48px;
  align-items: center;
  padding: 8px 16px;
  gap: 16px;
  border-radius: 8px;
  border: 1px solid rgba(229, 231, 235, 1);
  box-sizing: border-box;
  background: rgba(249, 250, 251, 1);
  font-family: 'Work Sans', sans-serif;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: rgba(107, 114, 128, 1);
  margin-top: 16px;

  & > p {
    margin: 0;
    white-space: nowrap;
  }

  & > i.fa.fa-filter {
    color: rgba(107, 114, 128, 1);
  }
`;

export const FiltersContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
`;

export const FilterItem = styled.div`
  border: 2px solid rgba(147, 197, 253, 1);
  border-radius: 4px;
  padding: 4px 8px;
  background-color: rgba(239, 246, 255, 1);
  display: flex;
  align-items: center;
  gap: 5px;
`;

export const FilterKey = styled.span`
  font-family: 'Work Sans', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  text-align: left;
`;

export const FilterValue = styled.span`
  font-family: 'Work Sans', sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  text-align: left;
`;

export const FilterRemoveButton = styled.button`
  background: none;
  border: none;
  font-weight: bold;
  font-size: 16px;
  cursor: pointer;
`;
